import { trackAnalyticsSafely } from "./AnalyticsTracker"
import {
    CollaboratorCreateFailureReason,
    CollaboratorDetailTabID,
    CollaboratorsSearchPayload,
    CollaboratorsTabID,
} from "./CollaboratorsEvents"

export class CollaboratorsAnalyticsHelper {
    static trackShown(tab: CollaboratorsTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Shown",
            payload: { tab },
        })
    }

    static trackTabSelected(tab: CollaboratorsTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.TabSelected",
            payload: { tab },
        })
    }

    static trackRefreshed(tab: CollaboratorsTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Refreshed",
            payload: { tab },
        })
    }

    static trackSearchApplied(payload: CollaboratorsSearchPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.SearchApplied",
            payload,
        })
    }

    static trackExported(tab: CollaboratorsTabID, count: number) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Exported",
            payload: { tab, count },
        })
    }

    static trackCreateModalOpened(tab: CollaboratorsTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.CreateModalOpened",
            payload: { tab },
        })
    }

    static trackCreateSubmitted(hasEmail: boolean) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.CreateSubmitted",
            payload: { hasEmail },
        })
    }

    static trackCreateSucceeded(collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.CreateSucceeded",
            payload: { collaboratorID },
        })
    }

    static trackCreateFailed(reason: CollaboratorCreateFailureReason) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.CreateFailed",
            payload: { reason },
        })
    }

    static trackDetailOpened(tab: CollaboratorsTabID, collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.DetailOpened",
            payload: { tab, collaboratorID },
        })
    }

    static trackDeactivateConfirmed(collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.DeactivateConfirmed",
            payload: { collaboratorID },
        })
    }

    static trackReactivateConfirmed(collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.ReactivateConfirmed",
            payload: { collaboratorID },
        })
    }

    static trackDetailShown(collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Detail.Shown",
            payload: { collaboratorID },
        })
    }

    static trackDetailTabSelected(collaboratorID: string, detailTab: CollaboratorDetailTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Detail.TabSelected",
            payload: { collaboratorID, detailTab },
        })
    }

    static trackDetailProfileSaved(collaboratorID: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Collaborators.Detail.ProfileSaved",
            payload: { collaboratorID },
        })
    }
}
